// GUARDED COPY of the Web's src/config/moveLibrary.js (2026-11-04): the move
// library's table, so HypeTown and the website list the same moves. Edit the Web
// original, then `node scripts/check_face_decal_sync.mjs --sync`.
/* ── VERBATIM FROM HypeTunes_Web_2026 BELOW THIS LINE ── */
/**
 * THE MOVE LIBRARY — every move any body can play: the 307 bought 2026-11-04, the
 * first set (2026-10-28), and recorded performance packs (vocals, guitar, drums,
 * instruments; converted by API docs/3d_body_renewal/prototype/anim/fbx2library).
 *
 * ⚠ ONE TABLE, TWO APPS. The World keeps a guarded copy (its
 * scripts/check_face_decal_sync.mjs), so nothing here may import from either
 * app: it names bucket objects, and each app turns a name into a URL its own
 * way (Web: the asset proxy, MoveLibraryPanel `moveUrl`; World: services/assets).
 *
 * Khari, 2026-11-03: *"It seems safer to just have all of them so we can
 * future-proof any situation."* 307 moves from the Meshy rigger, bought ONCE on a
 * spare mannequin (API scripts/buy_clip_library.js). Every body we build has the
 * same 25 bones, so any move plays on any body, fitted to that body's rest pose
 * as it loads (three/clipRetarget.js) — no body is re-rigged or charged again.
 *
 * ⚠ A LOOKUP TABLE, NOT A PRELOAD LIST. Nothing here downloads anything: a move
 * is fetched when it plays and released when it stops (ModelViewer3D `move`).
 * ⚠ THE FOLDER IS STAMPED. The asset proxy serves these `immutable`, so a move
 * that changes must change path: a new upload is a new STAMP, never an overwrite.
 * A row from an older folder names its stamp as its 8th field.
 * ⚠ NO GENERATED PERFORMANCES. The rigger's catalogue has no singing, mic, rap,
 * instrument or DJ action (FINDINGS §3). Four text-to-motion drafts were tried
 * (rap_inplace, rap_moving, sing_ballad, hype_man) and are LEFT OUT on purpose.
 * Khari, 2026-11-04: *"we should remove the handwritten ones so they are not
 * used."* Their files stay in clip-library/20261028a; nothing lists them.
 *
 * Source of truth for the measurements: API docs/3d_body_renewal/clip_library_20261104a.json.
 * Names and groups come from the Move Picker; `tag` is Khari's F / M / both call.
 * ⚠ '' MEANS UNISEX, like 'both' (Khari, 2026-11-04: *"null should only mean
 * unisex"*): a move styled for one gender must say so. Five M tags were added by
 * hand from the source's own names, for the male twins of moves he tagged F
 * (excited_walk_m, happy_jump_m, male_run_forward_pick_up_left,
 * sit_to_stand_transition_m, stand_to_sit_transition_m); a regeneration from the
 * picker must keep them. F / M are shown, never enforced: the artist decides.
 * Flags (measured on the mannequin): T = turns (>25°), B = bends (>25° lean),
 * D = drifts (root travels >15 cm — played in place, so a walk walks on the spot).
 */
export const MOVE_STAMP = '20261104a'
export const MOVE_BUCKET = 'hypetunes_world_models'

export const MOVE_GROUPS = ["Performance", "Standing", "Walking", "Turning", "Dancing", "Acting & emotion", "Everyday", "Sitting & getting up", "Resting", "Jumps", "Workout"]

const FLAG_NAMES = { T: 'turns', B: 'bends', D: 'drifts' }

// [key, name, group index, seconds, flags, tag, note, stamp?]
const ROWS = [
  ["perf_vocal_01", "Vocal 01", 0, 12.0, "T,D", "", "recorded stage vocal (rock or hip-hop); a travelling one walks the stage", "20261104d"],
  ["perf_vocal_02", "Vocal 02", 0, 17.13, "T,D", "", "recorded stage vocal (rock or hip-hop); a travelling one walks the stage", "20261104d"],
  ["perf_vocal_03", "Vocal 03", 0, 16.9, "D", "", "recorded stage vocal (rock or hip-hop); a travelling one walks the stage", "20261104d"],
  ["perf_vocal_04", "Vocal 04", 0, 14.67, "D", "", "recorded stage vocal (rock or hip-hop); a travelling one walks the stage", "20261104d"],
  ["perf_vocal_05", "Vocal 05", 0, 12.0, "D", "", "recorded stage vocal (rock or hip-hop); a travelling one walks the stage", "20261104d"],
  ["perf_vocal_06", "Vocal 06", 0, 19.58, "D", "", "recorded stage vocal (rock or hip-hop); a travelling one walks the stage", "20261104d"],
  ["perf_vocal_07", "Vocal 07", 0, 15.96, "D", "", "recorded stage vocal (rock or hip-hop); a travelling one walks the stage", "20261104d"],
  ["perf_vocal_08", "Vocal 08", 0, 15.83, "T,D", "", "recorded stage vocal (rock or hip-hop); a travelling one walks the stage", "20261104d"],
  ["perf_vocal_09", "Vocal 09", 0, 19.17, "T,D", "", "recorded stage vocal (rock or hip-hop); a travelling one walks the stage", "20261104d"],
  ["perf_vocal_10", "Vocal 10", 0, 21.46, "T,D", "", "recorded stage vocal (rock or hip-hop); a travelling one walks the stage", "20261104d"],
  ["perf_vocal_11", "Vocal 11", 0, 19.87, "T,D", "", "recorded stage vocal (rock or hip-hop); a travelling one walks the stage", "20261104d"],
  ["perf_vocal_12", "Vocal 12", 0, 18.08, "T,D", "", "recorded stage vocal (rock or hip-hop); a travelling one walks the stage", "20261104d"],
  ["perf_vocal_13", "Vocal 13", 0, 15.57, "T,D", "", "recorded stage vocal (rock or hip-hop); a travelling one walks the stage", "20261104d"],
  ["perf_vocal_14", "Vocal 14", 0, 13.03, "T,D", "", "recorded stage vocal (rock or hip-hop); a travelling one walks the stage", "20261104d"],
  ["perf_vocal_15", "Vocal 15", 0, 12.29, "T,D", "", "recorded stage vocal (rock or hip-hop); a travelling one walks the stage", "20261104d"],
  ["perf_guitar_01", "Guitar 01", 0, 12.75, "T,D", "", "recorded guitar (electric or bass); no guitar model yet", "20261104d"],
  ["perf_guitar_02", "Guitar 02", 0, 14.0, "T,D", "", "recorded guitar (electric or bass); no guitar model yet", "20261104d"],
  ["perf_guitar_03", "Guitar 03", 0, 15.13, "T,B,D", "", "recorded guitar (electric or bass); no guitar model yet", "20261104d"],
  ["perf_guitar_04", "Guitar 04", 0, 19.5, "T,D", "", "recorded guitar (electric or bass); no guitar model yet", "20261104d"],
  ["perf_guitar_05", "Guitar 05", 0, 15.0, "", "", "recorded guitar (electric or bass); no guitar model yet", "20261104d"],
  ["perf_guitar_06", "Guitar 06", 0, 10.07, "T,D", "", "recorded guitar (electric or bass); no guitar model yet", "20261104d"],
  ["perf_guitar_07", "Guitar 07", 0, 10.2, "", "", "recorded guitar (electric or bass); no guitar model yet", "20261104d"],
  ["perf_guitar_08", "Guitar 08", 0, 17.2, "T,D", "", "recorded guitar (electric or bass); no guitar model yet", "20261104d"],
  ["perf_guitar_09", "Guitar 09", 0, 17.29, "D", "", "recorded guitar (electric or bass); no guitar model yet", "20261104d"],
  ["perf_guitar_10", "Guitar 10", 0, 13.87, "", "", "recorded guitar (electric or bass); no guitar model yet", "20261104d"],
  ["perf_drum_01", "Drum 01", 0, 19.79, "", "", "recorded drums; seated, no drum kit yet", "20261104d"],
  ["perf_drum_02", "Drum 02", 0, 14.17, "", "", "recorded drums; seated, no drum kit yet", "20261104d"],
  ["perf_drum_03", "Drum 03", 0, 12.79, "", "", "recorded drums; seated, no drum kit yet", "20261104d"],
  ["perf_drum_04", "Drum 04", 0, 12.87, "", "", "recorded drums; seated, no drum kit yet", "20261104d"],
  ["perf_drum_05", "Drum 05", 0, 12.53, "", "", "recorded drums; seated, no drum kit yet", "20261104d"],
  ["play_drums", "Drums", 0, 11.9, "", "", "recorded performance; seated, no drum kit yet", "20261104d"],
  ["play_electric_guitar", "Electric Guitar", 0, 10.8, "T,D", "", "recorded performance; no guitar model yet", "20261104d"],
  ["play_flute", "Flute", 0, 10.43, "D", "", "recorded performance; no flute model yet", "20261104d"],
  ["play_guitar_sitting", "Guitar (sitting)", 0, 12.2, "", "", "recorded performance; seated, no guitar model yet", "20261104d"],
  ["play_piano", "Piano", 0, 8.47, "", "", "recorded performance; seated, no piano yet", "20261104d"],
  ["play_violin", "Violin", 0, 14.6, "", "", "recorded performance; no violin model yet", "20261104d"],
  ["alert", "Alert", 1, 4.03, "", "", ""],
  ["angry_ground_stomp", "Angry Ground Stomp", 1, 1.4, "", "", ""],
  ["angry_ground_stomp_1", "Angry Ground Stomp 1", 1, 1.4, "", "", ""],
  ["angry_ground_stomp_2", "Angry Ground Stomp 2", 1, 1.83, "T", "", ""],
  ["arise", "Arise", 1, 1.87, "B,D", "", ""],
  ["axe_breathe_and_look_around", "Axe Breathe and Look Around", 1, 11.3, "D", "", ""],
  ["confused_scratch", "Confused Scratch", 1, 11.53, "D", "", ""],
  ["crawl_and_look_back", "Crawl and Look Back", 1, 6.93, "T,B,D", "", ""],
  ["crouchlookaroundbow", "CrouchLookAroundBow", 1, 5.87, "", "", ""],
  ["dozing_elderly", "Dozing Elderly", 1, 10.87, "", "", ""],
  ["idle_02", "Idle 02", 1, 1.9, "", "", "wide planted stance, slight sway"],
  ["idle_03", "Idle 03", 1, 4.3, "", "", "stretches arms OVERHEAD"],
  ["idle_10", "Idle 10", 1, 3.7, "", "", "boxing guard"],
  ["idle_11", "Idle 11", 1, 1.9, "", "", "calm hero stand"],
  ["idle_12", "Idle 12", 1, 6.03, "", "", "calm stand"],
  ["idle_13", "Idle 13", 1, 11.4, "D", "", "combat stance"],
  ["idle_14", "Idle 14", 1, 7.53, "T,D", "", "combat stance + kick"],
  ["idle_15", "Idle 15", 1, 7.03, "D", "", "casual stand, hand rises to talk"],
  ["idle_3", "Idle 3", 1, 10.0, "", "", "first set", "20261028a"],
  ["idle_4", "Idle 4", 1, 14.0, "", "", "calm stand"],
  ["idle_5", "Idle 5", 1, 1.87, "", "", "combat crouch"],
  ["idle_7", "Idle 7", 1, 8.77, "", "", "calm stand"],
  ["idle_8", "Idle 8", 1, 8.03, "", "", "combat crouch"],
  ["idle_9", "Idle 9", 1, 2.03, "", "", "first set", "20261028a"],
  ["listening_gesture", "Listening Gesture", 1, 9.37, "D", "", "first set", "20261028a"],
  ["long_breathe_and_look_around", "Long Breathe and Look Around", 1, 11.3, "", "", ""],
  ["look_around_dumbfounded", "Look Around Dumbfounded", 1, 6.37, "T", "", ""],
  ["lower_weapon_look_raise", "Lower Weapon Look Raise", 1, 5.2, "T", "", ""],
  ["mirror_viewing", "Mirror Viewing", 1, 7.37, "T,B,D", "", ""],
  ["short_breathe_and_look_around", "Short Breathe and Look Around", 1, 7.87, "", "", ""],
  ["torch_look_around", "Torch Look Around", 1, 9.37, "T", "", ""],
  ["walk_slowly_and_look_around", "Walk Slowly and Look Around", 1, 23.83, "D", "", ""],
  ["walking_scan_with_sudden_look_back", "Walking Scan with Sudden Look Back", 1, 6.73, "T,D", "", ""],
  ["carry_heavy_cannon_forward", "Carry Heavy Cannon Forward", 2, 0.97, "", "", ""],
  ["carry_heavy_object_walk", "Carry Heavy Object Walk", 2, 6.53, "D", "", ""],
  ["carry_water_bucket_walk", "Carry Water Bucket Walk", 2, 9.3, "B,D", "", ""],
  ["confident_strut", "Confident Strut", 2, 2.7, "", "", "travels; use 621"],
  ["confident_walk", "Confident Walk", 2, 5.77, "", "", ""],
  ["crawl_backward", "Crawl Backward", 2, 1.0, "B,D", "", ""],
  ["elderly_shaky_walk", "Elderly Shaky Walk", 2, 2.87, "D", "", ""],
  ["flirty_strut", "Flirty Strut", 2, 3.23, "", "", ""],
  ["funky_walk", "Funky Walk", 2, 1.9, "D", "", "travels; use 632"],
  ["injured_walk", "Injured Walk", 2, 8.7, "", "", ""],
  ["injured_walk_backward", "Injured Walk Backward", 2, 1.67, "D", "", ""],
  ["limping_walk", "Limping Walk", 2, 3.53, "D", "", ""],
  ["limping_walk_1", "Limping Walk 1", 2, 1.53, "T,D", "", ""],
  ["limping_walk_2", "Limping Walk 2", 2, 2.47, "D", "", ""],
  ["limping_walk_3", "Limping Walk 3", 2, 2.9, "T,D", "", ""],
  ["monster_walk", "Monster Walk", 2, 4.13, "T", "", ""],
  ["proud_strut", "Proud Strut", 2, 4.53, "D", "", ""],
  ["quick_walk", "Quick Walk", 2, 3.03, "", "", ""],
  ["red_carpet_walk", "Red Carpet Walk", 2, 6.0, "", "f", "walk + wave; use 653"],
  ["run_to_walk_transition", "Run to Walk Transition", 2, 2.3, "D", "", ""],
  ["skip_forward", "Skip Forward", 2, 2.87, "", "", ""],
  ["slow_orc_walk", "Slow Orc Walk", 2, 5.53, "T,B,D", "", ""],
  ["sneaky_walk", "Sneaky Walk", 2, 2.87, "B,D", "", ""],
  ["spear_walk", "Spear Walk", 2, 1.13, "", "", ""],
  ["step_back", "Step Back", 2, 0.9, "D", "", ""],
  ["step_hip_hop_dance", "Step Hip Hop Dance", 2, 2.6, "D", "", "hip-hop step, hand to chest; Walking subcategory, no in-place variant (likely travels)"],
  ["stumble_walk", "Stumble Walk", 2, 2.6, "T,B,D", "", ""],
  ["stylish_walk", "Stylish Walk", 2, 3.53, "D", "", "travels; use 675"],
  ["texting_walk", "Texting Walk", 2, 2.03, "", "", ""],
  ["thoughtful_walk", "Thoughtful Walk", 2, 4.73, "", "", ""],
  ["tightrope_walk", "Tightrope Walk", 2, 5.2, "T,B,D", "", ""],
  ["unsteady_walk", "Unsteady Walk", 2, 3.0, "T,D", "", ""],
  ["walk_backward", "Walk Backward", 2, 0.9, "D", "", ""],
  ["walk_backward_with_bow", "Walk Backward with Bow", 2, 1.53, "D", "", ""],
  ["walk_backward_with_bow_1", "Walk Backward with Bow 1", 2, 1.53, "D", "", ""],
  ["walk_backward_with_grenade", "Walk Backward with Grenade", 2, 1.23, "D", "", ""],
  ["walk_backward_with_gun_1", "Walk Backward with Gun 1", 2, 1.03, "D", "", ""],
  ["walk_backward_with_sword", "Walk Backward with Sword", 2, 1.37, "D", "", ""],
  ["walk_backward_with_sword_shield", "Walk Backward with Sword Shield", 2, 1.3, "D", "", ""],
  ["walk_fight_back", "Walk Fight Back", 2, 1.73, "", "", ""],
  ["walk_fight_forward", "Walk Fight Forward", 2, 1.73, "", "", ""],
  ["walk_with_umbrella", "Walk with Umbrella", 2, 1.37, "D", "", ""],
  ["walk_with_walker_support", "Walk with Walker Support", 2, 3.7, "D", "", ""],
  ["walking_2", "walking 2", 2, 1.2, "D", "", ""],
  ["walking_with_phone", "Walking with Phone", 2, 2.53, "", "", ""],
  ["walking_woman", "Walking Woman", 2, 1.0, "", "f", ""],
  ["alert_quick_turn_right", "Alert Quick Turn Right", 3, 2.83, "T", "", ""],
  ["combat_idle_turn_left", "Combat Idle Turn Left", 3, 1.3, "T,D", "", ""],
  ["depressed_full_turn_left", "Depressed Full Turn Left", 3, 8.83, "T,D", "", ""],
  ["frustrated_turn_right", "Frustrated Turn Right", 3, 1.23, "T,D", "", ""],
  ["idle_step_turn_left", "Idle Step Turn Left", 3, 1.03, "T,D", "", ""],
  ["idle_torch_turn_left", "Idle Torch Turn Left", 3, 1.33, "T,D", "", ""],
  ["idle_turn_left", "Idle Turn Left", 3, 0.97, "T,D", "", ""],
  ["idle_turn_right", "Idle Turn Right", 3, 1.13, "T", "", ""],
  ["rifle_aim_turn_right", "Rifle Aim Turn Right", 3, 1.83, "T,D", "", ""],
  ["rifle_turn_left", "Rifle Turn Left", 3, 1.53, "T,D", "", ""],
  ["run_sharp_turn_right", "Run Sharp Turn Right", 3, 1.2, "T,B,D", "", ""],
  ["run_turn_left", "Run Turn Left", 3, 1.63, "T,B,D", "", ""],
  ["run_turn_right", "Run Turn Right", 3, 1.63, "T,D", "", ""],
  ["sword_and_shield_alert_turn_left", "Sword and Shield Alert Turn Left", 3, 1.37, "T,D", "", ""],
  ["sword_and_shield_alert_turn_right", "Sword and Shield Alert Turn Right", 3, 3.37, "T,D", "", ""],
  ["walk_turn_left", "Walk Turn Left", 3, 2.03, "T,D", "", ""],
  ["walk_turn_left_with_weapon", "Walk Turn Left with Weapon", 3, 2.23, "T,D", "", ""],
  ["walk_turn_right", "Walk Turn Right", 3, 2.2, "T,D", "", ""],
  ["walk_turn_right_female", "Walk Turn Right Female", 3, 3.7, "T,D", "f", ""],
  ["walk_turn_right_idle_style", "Walk Turn Right Idle Style", 3, 1.17, "T,D", "", ""],
  ["all_night_dance", "All Night Dance", 4, 8.2, "T,B,D", "", "turns side/back on; camera zoomed out (travels)"],
  ["arm_circle_shuffle", "Arm Circle Shuffle", 4, 9.7, "T,D", "", "one overhead arm; camera zoomed out (travels)"],
  ["bass_beats", "Bass Beats", 4, 6.2, "T,B,D", "f", "first set: stage, female performers", "20261028a"],
  ["boom_dance", "Boom Dance", 4, 7.17, "B,D", "f", "first set: stage, female performers", "20261028a"],
  ["bubble_dance", "Bubble Dance", 4, 8.07, "T,B,D", "", "pop groove, hands chest/head, mostly front"],
  ["cardio_dance", "Cardio Dance", 4, 4.33, "D", "", "aerobic: arms out wide, leg kicks out"],
  ["cherish_pop_dance", "Cherish Pop Dance", 4, 15.7, "T,B,D", "", "repeated OVERHEAD arm raises + T-arms, turns"],
  ["dont_you_dare", "Dont You Dare", 4, 6.03, "T,B,D", "", "hands on top of head (OVERHEAD), crouch, profile"],
  ["fast_lightning", "Fast Lightning", 4, 10.87, "T,D", "", "repeated disco point straight UP (OVERHEAD)"],
  ["funnydancing_01", "FunnyDancing 01", 4, 7.77, "T,B,D", "", "front-facing goofy groove with leg kicks; in place"],
  ["funnydancing_02", "FunnyDancing 02", 4, 7.53, "D", "", "low crouched groove, hands near head; front-facing"],
  ["funnydancing_03", "FunnyDancing 03", 4, 8.03, "T,D", "", "squat + arm swing then upright; front-facing"],
  ["gangnam_groove", "Gangnam Groove", 4, 10.17, "T,D", "", "OVERHEAD lasso arm + knee hops"],
  ["hip_hop_dance", "Hip Hop Dance", 4, 3.37, "B,D", "", "front, forearms up, hands ~head level, bounce - moderate"],
  ["hip_hop_dance_1", "Hip Hop Dance 1", 4, 3.37, "B,D", "", "first set: crowd", "20261028a"],
  ["hip_hop_dance_2", "Hip Hop Dance 2", 4, 6.13, "T,B,D", "", "knee lifts, turns to profile"],
  ["hip_hop_dance_3", "Hip Hop Dance 3", 4, 4.73, "T,D", "", "knee-up groove, bent arms, front"],
  ["hip_hop_dance_4", "Hip Hop Dance 4", 4, 4.9, "B,D", "", "knee lifts, one brief overhead arm"],
  ["indoor_swing", "Indoor Swing", 4, 8.03, "T,B,D", "", "swing-dance leans, profile turns"],
  ["jazz_danc", "jazz danc", 4, 2.77, "D", "", "OVERHEAD arms + travel"],
  ["joyful_dance_with_hand_sway", "Joyful Dance with Hand Sway", 4, 6.6, "", "", "first set: crowd", "20261028a"],
  ["love_you_pop_dance", "Love You Pop Dance", 4, 10.03, "T,B,D", "", "pop, turns to profile, hands at head"],
  ["magic_genie", "Magic Genie", 4, 6.03, "T,B,D", "", "arms forward then OVERHEAD"],
  ["not_your_mom", "Not Your Mom", 4, 7.03, "T,B,D", "", "arm sweeps, some turning, hand to head"],
  ["omg_groove", "OMG Groove", 4, 13.53, "T,B,D", "", "T-arms, turns"],
  ["pod_baby_groove", "Pod Baby Groove", 4, 13.37, "T,B,D", "", "both arms OVERHEAD repeatedly"],
  ["pop_dance_lsa2", "Pop Dance LSA2", 4, 11.07, "T,B,D", "", "small in frame (travels), profile turns"],
  ["shake_it_off_dance", "Shake It Off Dance", 4, 16.3, "T,B,D", "", "front, in place, elbows up to head height (raise-the-roof) - moderate"],
  ["squat_stance", "Squat Stance", 4, 4.77, "T,B,D", "", "drops to a kneel/floor - not a stage groove"],
  ["superlove_pop_dance", "Superlove Pop Dance", 4, 8.53, "T,B,D", "", "arms-out pop, mostly front"],
  ["ymca_dance", "ymca dance", 4, 4.53, "T", "", "YMCA letters - OVERHEAD"],
  ["you_groove", "You Groove", 4, 13.53, "T,B,D", "", "hands-on-hips groove, front - SAFE"],
  ["360_power_spin_jump", "360 Power Spin Jump", 5, 3.07, "T,B,D", "", ""],
  ["backflip_and_hooks", "Backflip and Hooks", 5, 5.87, "T,B,D", "", ""],
  ["backflip_and_rise", "Backflip and Rise", 5, 2.7, "B,D", "", ""],
  ["baseball_pitching", "baseball pitching", 5, 4.0, "T,B,D", "", ""],
  ["big_heart_gesture", "Big Heart Gesture", 5, 6.2, "", "", "heart shape with both arms OVERHEAD"],
  ["boxing_warmup", "Boxing Warmup", 5, 6.37, "T,B,D", "", ""],
  ["breakdance_1990", "Breakdance 1990", 5, 0.53, "T", "", "handstand breakdance; preview only 13 frames"],
  ["burpee_exercise", "Burpee Exercise", 5, 3.2, "B,D", "", ""],
  ["call_gesture", "Call Gesture", 5, 7.53, "T,D", "", "one arm raised beckoning + hand to ear (\"make some noise\") - one arm goes overhead"],
  ["catching_breath", "Catching Breath", 5, 7.03, "B,D", "", ""],
  ["clapping_run", "Clapping Run", 5, 13.7, "T,D", "", "claps OVERHEAD; name says run"],
  ["crouch_and_step_back", "Crouch and Step Back", 5, 2.7, "T,B,D", "", ""],
  ["crouch_charge_and_throw", "Crouch Charge and Throw", 5, 7.7, "T,D", "", ""],
  ["double_kick_forward", "Double kick forward", 5, 2.6, "T,B,D", "", ""],
  ["excited_walk_f", "Excited Walk F", 5, 9.77, "T,B,D", "f", ""],
  ["excited_walk_m", "Excited Walk M", 5, 10.7, "T,D", "m", ""],
  ["finger_wag_no", "Finger Wag No", 5, 5.03, "B,D", "", ""],
  ["grip_and_throw_down", "Grip and Throw Down", 5, 4.7, "D", "", ""],
  ["groovy_walk", "Groovy Walk", 5, 5.0, "T,D", "", "travels (walk)"],
  ["ground_flip_and_sweep_up", "Ground Flip and Sweep Up", 5, 4.03, "T,B,D", "", ""],
  ["half_squat_with_thumb_up", "Half Squat with Thumb Up", 5, 3.73, "T,B,D", "", "odd squat/thumb-up"],
  ["handbag_walk", "Handbag Walk", 5, 3.7, "", "f", ""],
  ["handstand_flip", "Handstand Flip", 5, 3.33, "T,B,D", "", ""],
  ["happy_jump_f", "Happy jump f", 5, 9.87, "T,B,D", "f", "jumps with arms OVERHEAD"],
  ["happy_jump_m", "happy jump m", 5, 9.87, "T,B,D", "m", "celebratory hop, arm swing, leg kick"],
  ["happy_sway_standing", "Happy Sway Standing", 5, 10.03, "D", "", "gentle side sway, low arms, front - SAFE"],
  ["head_hold_in_pain", "Head Hold in Pain", 5, 3.73, "T,D", "", ""],
  ["hit_in_back_while_running", "Hit in Back While Running", 5, 2.53, "B,D", "", ""],
  ["hop_with_arms_raised", "Hop with Arms Raised", 5, 2.37, "", "", "arms OVERHEAD on hop"],
  ["indoor_play", "Indoor Play", 5, 6.5, "T,B,D", "", "runs around (travels)"],
  ["jazz_hands", "Jazz Hands", 5, 2.77, "D", "", "OVERHEAD jazz hands + knee lifts"],
  ["jump_and_slam_back_down", "Jump and Slam Back Down", 5, 2.77, "T,B,D", "", ""],
  ["jump_rope", "Jump Rope", 5, 8.57, "D", "", ""],
  ["jump_to_catch_and_fall", "Jump to Catch and Fall", 5, 4.2, "T,B,D", "", ""],
  ["kick_a_soccer_ball", "Kick a Soccer Ball", 5, 1.67, "T,D", "", ""],
  ["large_step_then_high_kick", "Large step then high kick", 5, 2.03, "T,B,D", "", ""],
  ["left_hand_bitten_step_back", "Left Hand Bitten Step Back", 5, 4.07, "T,B,D", "", ""],
  ["mummy_stagger", "Mummy Stagger", 5, 4.87, "T,D", "", ""],
  ["neck_slashing_gesture", "Neck Slashing Gesture", 5, 4.23, "", "", ""],
  ["over_shoulder_throw", "Over Shoulder Throw", 5, 4.33, "T,B,D", "", ""],
  ["penguin_walk", "penguin walk", 5, 2.03, "", "", ""],
  ["punch_pose", "Punch Pose", 5, 4.33, "T,D", "", ""],
  ["quick_step_and_spin_dodge", "Quick Step and Spin Dodge", 5, 1.2, "T,D", "", ""],
  ["relax_arms_then_strike_battle_pose", "Relax arms then strike battle pose", 5, 4.03, "T,D", "", ""],
  ["rising_flying_kick", "Rising Flying Kick", 5, 1.53, "T,B,D", "", ""],
  ["run_and_leap", "Run and Leap", 5, 2.7, "D", "", ""],
  ["shouting_angrily", "Shouting Angrily", 5, 7.2, "T,B,D", "", "hands to head, roar, arms out - hype yell"],
  ["show_both_arm_muscles", "Show Both Arm Muscles", 5, 1.9, "", "", "double-bicep flex, hands at head height"],
  ["shrug", "Shrug", 5, 2.03, "", "", "first set", "20261028a"],
  ["side_jumps_in_horse_stance", "Side jumps in horse stance", 5, 7.37, "B,D", "", "side-to-side hop, fists at chest, front - bounce proxy"],
  ["skill_01", "Skill 01", 5, 1.1, "T,D", "", "martial stance"],
  ["skill_02", "Skill 02", 5, 1.33, "T,B,D", "", "martial"],
  ["skill_03", "Skill 03", 5, 1.67, "T,B,D", "", "martial"],
  ["sprint_roll_and_flip", "Sprint Roll and Flip", 5, 2.77, "T,B,D", "", ""],
  ["stand_on_pole_and_balance", "Stand on Pole and Balance", 5, 1.87, "B,D", "", ""],
  ["step_right_for_exercise", "Step Right for Exercise", 5, 2.53, "T,B,D", "", "big lunging step (exercise)"],
  ["step_step_turn_kick", "Step Step Turn Kick", 5, 2.03, "T,B,D", "", ""],
  ["sword_shout", "Sword Shout", 5, 6.2, "T,D", "", ""],
  ["thomas_flair_to_jump_up", "Thomas Flair to Jump Up", 5, 2.53, "T,B,D", "", ""],
  ["victory", "victory", 5, 8.57, "T", "", "arms raised bent to head height"],
  ["victory_cheer", "Victory Cheer", 5, 9.37, "T,D", "", "arms OVERHEAD then one-arm pump"],
  ["victory_fist_pump", "Victory Fist Pump", 5, 1.53, "", "", "fist pumps at chest level, front, in place - SAFE"],
  ["wall_push_jump_and_flip", "Wall Push Jump and Flip", 5, 2.03, "T,B,D", "", ""],
  ["zombie_scream", "Zombie Scream", 5, 2.83, "B", "", ""],
  ["agree_gesture", "Agree Gesture", 6, 13.03, "T,D", "both", "fists up to shoulders, hands together"],
  ["angry_stomp", "Angry Stomp", 6, 8.03, "T,D", "both", ""],
  ["big_wave_hello", "Big Wave Hello", 6, 5.37, "B,D", "", "first set", "20261028a"],
  ["checkout_gesture", "Checkout Gesture", 6, 6.5, "D", "", "low gesture"],
  ["cheer", "Cheer", 6, 2.23, "", "", "first set", "20261028a"],
  ["cheer_with_both_hands", "Cheer with Both Hands", 6, 2.97, "", "", "both arms OVERHEAD throughout"],
  ["cheer_with_both_hands_1", "Cheer with Both Hands 1", 6, 2.2, "", "", "hand to side of head (cup/shout), one arm up at end"],
  ["cheer_with_both_hands_up", "Cheer with Both Hands Up", 6, 1.9, "", "", "both arms OVERHEAD"],
  ["cheer_with_one_hand_up", "Cheer with One Hand Up", 6, 1.7, "T", "", "misnamed - BOTH arms go OVERHEAD"],
  ["collect_object", "Collect Object", 6, 6.03, "", "both", ""],
  ["crouch_and_push_forward", "Crouch and Push Forward", 6, 3.7, "B,D", "", ""],
  ["discuss_while_moving", "Discuss While Moving", 6, 8.03, "D", "", "small travel while talking"],
  ["female_bend_over_pick_up_inspect", "Female Bend Over Pick Up Inspect", 6, 3.87, "T,B,D", "f", ""],
  ["female_crouch_pick_fruit_basket_stand", "Female Crouch Pick Fruit Basket Stand", 6, 7.13, "B,D", "f", ""],
  ["female_crouch_pick_gun_point_forward", "Female Crouch Pick Gun Point Forward", 6, 2.47, "T,B,D", "f", ""],
  ["female_crouch_pick_throw_forward", "Female Crouch Pick Throw Forward", 6, 4.9, "T,B,D", "f", ""],
  ["female_crouch_pick_up_place_side", "Female Crouch Pick Up Place Side", 6, 9.57, "B", "f", ""],
  ["female_run_forward_pick_up_right", "Female Run Forward Pick Up Right", 6, 1.23, "B,D", "f", ""],
  ["female_stand_pick_fruit_basket", "Female Stand Pick Fruit Basket", 6, 6.2, "", "f", ""],
  ["female_walk_pick_put_in_pocket", "Female Walk Pick Put In Pocket", 6, 9.53, "T,B,D", "f", ""],
  ["formal_bow", "Formal Bow", 6, 7.7, "B,D", "both", "deep bow, arms at sides - SAFE"],
  ["gentlemans_bow", "Gentlemans Bow", 6, 7.3, "B,D", "both", "arm-sweep theatrical bow (arm horizontal)"],
  ["gesture_with_hand_on_gun", "Gesture with Hand on Gun", 6, 6.2, "", "", ""],
  ["hand_on_hip_gesture", "Hand on Hip Gesture", 6, 5.03, "D", "", "hand on hip, free hand rises to face - SAFE"],
  ["headache_relief", "Headache Relief", 6, 4.87, "", "", ""],
  ["male_bend_over_pick_up", "Male Bend Over Pick Up", 6, 7.2, "B,D", "f", ""],
  ["male_run_forward_pick_up_left", "Male Run Forward Pick Up Left", 6, 1.2, "T,B,D", "m", ""],
  ["motivational_cheer", "Motivational Cheer", 6, 9.03, "T,D", "f", "flex + fist pump, arms to head height"],
  ["open_door", "open door", 6, 5.23, "T", "", ""],
  ["open_door_1", "open door 1", 6, 5.23, "T", "", ""],
  ["open_door_2", "open door 2", 6, 9.7, "T,D", "", ""],
  ["open_door_3", "open door 3", 6, 10.87, "T,B,D", "", ""],
  ["open_door_4", "open door 4", 6, 8.1, "T,B,D", "both", ""],
  ["personalized_gesture", "Personalized Gesture", 6, 2.03, "T,D", "", "one arm points straight UP, then hand to face"],
  ["phone_call_gesture", "Phone Call Gesture", 6, 10.07, "T,D", "both", "right hand held at side of face whole clip (phone) - only sustained hand-at-head hold"],
  ["phone_conversation", "Phone Conversation", 6, 4.87, "D", "", ""],
  ["pull_radish", "Pull Radish", 6, 4.73, "B", "both", ""],
  ["push_and_walk_forward", "Push and Walk Forward", 6, 8.03, "T,B,D", "both", ""],
  ["push_forward_and_stop", "Push Forward and Stop", 6, 2.6, "T,B,D", "both", ""],
  ["scheming_hand_rub", "Scheming Hand Rub", 6, 3.33, "D", "", "hand rub, hunch"],
  ["seated_fist_pump", "Seated Fist Pump", 6, 3.3, "", "", "seated"],
  ["sit_cheer_with_left_hand", "Sit Cheer with Left Hand", 6, 2.7, "", "", ""],
  ["sitting_answering_questions", "Sitting Answering Questions", 6, 9.7, "", "", ""],
  ["stand_and_chat", "Stand and Chat", 6, 5.2, "T,D", "", "low conversational gestures"],
  ["stand_and_drink", "Stand and Drink", 6, 8.9, "", "", "first set", "20261028a"],
  ["stand_cheer_and_sit_down", "Stand Cheer and Sit Down", 6, 3.5, "D", "", ""],
  ["stand_clap_and_sit_down", "Stand Clap and Sit Down", 6, 4.2, "B,D", "", "starts/ends seated"],
  ["stand_talking_angry", "Stand Talking Angry", 6, 20.83, "D", "", ""],
  ["stand_wave_and_sit_down", "Stand Wave and Sit Down", 6, 3.5, "D", "", ""],
  ["step_forward_and_push", "Step Forward and Push", 6, 4.73, "T,B,D", "", ""],
  ["talk_passionately", "Talk Passionately", 6, 10.3, "", "", "first set", "20261028a"],
  ["talk_with_hands_open", "Talk with Hands Open", 6, 4.0, "", "", "first set", "20261028a"],
  ["talk_with_left_hand_on_hip", "Talk with Left Hand on Hip", 6, 5.2, "", "", "first set", "20261028a"],
  ["talk_with_left_hand_raised", "Talk with Left Hand Raised", 6, 4.67, "", "", "conversational hand at chest/head height - SAFE"],
  ["talk_with_right_hand_open", "Talk with Right Hand Open", 6, 3.8, "", "", "first set", "20261028a"],
  ["wave_for_help", "Wave for Help", 6, 5.07, "B", "", ""],
  ["wave_for_help_1", "Wave for Help 1", 6, 0.57, "", "both", ""],
  ["wave_for_help_2", "Wave for Help 2", 6, 1.53, "", "", ""],
  ["wave_for_help_3", "Wave for Help 3", 6, 3.2, "", "both", ""],
  ["wave_for_help_4", "Wave for Help 4", 6, 4.73, "", "", ""],
  ["angry_to_tantrum_sit", "Angry To Tantrum Sit", 7, 8.53, "T,B,D", "", ""],
  ["chair_sit_idle_f", "Chair Sit Idle F", 7, 11.37, "B", "f", "first set", "20261028a"],
  ["chair_sit_idle_m", "Chair Sit Idle M", 7, 10.7, "", "m", "first set", "20261028a"],
  ["falling_down", "falling down", 7, 2.3, "T,B,D", "", ""],
  ["kneel_on_one_knee_and_stand", "Kneel on One Knee and Stand", 7, 2.57, "T,D", "", ""],
  ["lie_back_leg_swing", "Lie Back Leg Swing", 7, 2.47, "T,B,D", "", ""],
  ["look_back_and_sit", "Look Back and Sit", 7, 2.3, "T,D", "", ""],
  ["prone_reach_help", "Prone Reach Help", 7, 18.43, "", "", ""],
  ["sidelying_reach_help", "SideLying Reach Help", 7, 14.7, "B", "", ""],
  ["sit_and_drink", "Sit and Drink", 7, 11.2, "", "", "first set", "20261028a"],
  ["sit_cross_legged", "Sit Cross Legged", 7, 9.57, "", "", ""],
  ["sit_cross_legged_on_floor", "Sit Cross Legged on Floor", 7, 2.53, "", "", ""],
  ["sit_dodge", "Sit Dodge", 7, 8.9, "B", "", ""],
  ["sit_finger_wag_no", "Sit Finger Wag No", 7, 4.0, "", "", ""],
  ["sit_hands_on_head_lean_back", "Sit Hands on Head Lean Back", 7, 4.83, "B", "", ""],
  ["sit_lie_bed", "Sit Lie Bed", 7, 7.67, "B", "", ""],
  ["sit_on_chair_arms_crossed", "Sit on Chair Arms Crossed", 7, 2.4, "", "", ""],
  ["sit_shout_hands_on_mouth", "Sit Shout Hands on Mouth", 7, 2.03, "", "", ""],
  ["sit_thumbs_up_right", "Sit Thumbs Up Right", 7, 3.87, "B", "", "seated"],
  ["sit_to_stand_transition_f", "Sit to Stand Transition F", 7, 4.73, "D", "f", ""],
  ["sit_to_stand_transition_m", "Sit to Stand Transition M", 7, 6.2, "B,D", "m", ""],
  ["sit_to_standtransition_female_2", "Sit to standTransition Female 2", 7, 2.3, "B,D", "f", ""],
  ["sitting_clap", "Sitting Clap", 7, 3.37, "", "", "seated clap"],
  ["stand_to_side_lying", "Stand To Side Lying", 7, 9.7, "T,B,D", "", ""],
  ["stand_to_sit_transition_m", "Stand to Sit Transition M", 7, 4.8, "B,D", "m", "first set", "20261028a"],
  ["stand_up1", "Stand Up1", 7, 8.3, "B,D", "", ""],
  ["stand_up10", "Stand Up10", 7, 7.7, "T,B,D", "", ""],
  ["stand_up2", "Stand Up2", 7, 3.1, "B,D", "", ""],
  ["stand_up3", "Stand Up3", 7, 6.07, "B,D", "", ""],
  ["stand_up4", "Stand Up4", 7, 1.7, "T,B,D", "", ""],
  ["stand_up5", "Stand Up5", 7, 11.4, "B,D", "", ""],
  ["stand_up6", "Stand Up6", 7, 6.7, "T,B,D", "", ""],
  ["stand_up7", "Stand Up7", 7, 2.73, "B,D", "", ""],
  ["stand_up8", "Stand Up8", 7, 2.37, "B,D", "", ""],
  ["stand_up9", "Stand Up9", 7, 2.47, "T,B,D", "", ""],
  ["step_to_sit_transition", "Step to Sit Transition", 7, 5.7, "T,B,D", "", ""],
  ["walk_to_sit", "Walk to Sit", 7, 8.37, "T,B,D", "", "first set", "20261028a"],
  ["cough_while_sleeping", "Cough While Sleeping", 8, 1.7, "", "", ""],
  ["groan_holding_stomach_in_sleep", "Groan Holding Stomach in Sleep", 8, 2.2, "B", "", ""],
  ["lie_down_hands_spread", "Lie Down Hands Spread", 8, 3.73, "", "", ""],
  ["lie_on_chair_sunbathe_and_sleep", "Lie on Chair Sunbathe and Sleep", 8, 11.53, "", "", ""],
  ["sit_and_doze_off", "Sit and Doze Off", 8, 17.33, "", "", ""],
  ["sleep", "sleep", 8, 5.73, "B,D", "", ""],
  ["sleep_normally", "Sleep Normally", 8, 1.73, "", "", ""],
  ["sleep_on_desk", "Sleep on Desk", 8, 23.87, "", "", ""],
  ["toss_and_turn", "Toss and Turn", 8, 17.67, "T,B,D", "", ""],
  ["wake_up_and_look_up", "Wake Up and Look Up", 8, 3.53, "", "", ""],
  ["back_jump", "Back Jump", 9, 0.97, "D", "", ""],
  ["backflip_jump", "Backflip Jump", 9, 4.13, "B,D", "", ""],
  ["jump_over_obstacle", "Jump Over Obstacle", 9, 2.03, "T,B,D", "", ""],
  ["jump_over_obstacle_1", "Jump Over Obstacle 1", 9, 1.2, "T,B,D", "", ""],
  ["jump_over_obstacle_2", "Jump Over Obstacle 2", 9, 0.9, "D", "", ""],
  ["jump_with_arms_and_legs_open", "Jump with Arms and Legs Open", 9, 2.53, "B,D", "", "side-on big jump"],
  ["jump_with_arms_open", "Jump with Arms Open", 9, 3.7, "B,D", "", "big vertical jump (leaves frame)"],
  ["jumping_down", "Jumping Down", 9, 3.3, "D", "", ""],
  ["leap_right_and_catch", "Leap Right and Catch", 9, 2.7, "D", "", ""],
  ["regular_jump", "Regular Jump", 9, 1.9, "T,D", "", "big vertical jump, arms up (leaves frame)"],
  ["run_and_jump", "Run and Jump", 9, 2.37, "T,B,D", "", ""],
  ["air_squat", "air squat", 10, 1.9, "", "", ""],
  ["bicep_curl", "bicep curl", 10, 5.9, "", "both", ""],
  ["bicycle_crunch", "bicycle crunch", 10, 1.17, "", "", ""],
  ["circle_crunch", "circle crunch", 10, 2.37, "B", "", ""],
  ["golf_drive", "golf drive", 10, 3.1, "T,B,D", "", ""],
  ["idle_to_push_up", "idle to push up", 10, 2.6, "T,B,D", "both", ""],
  ["jump_push_up", "jump push up", 10, 1.2, "", "", ""],
  ["jumping_jacks", "jumping jacks", 10, 1.13, "", "both", "jumping jacks OVERHEAD"],
  ["kettlebell_swing", "kettlebell swing", 10, 5.87, "B,D", "", ""],
  ["kettlebell_swing_1", "kettlebell swing 1", 10, 5.87, "B,D", "", ""],
  ["push_up", "push up", 10, 1.53, "", "both", ""],
  ["push_up_to_idle", "push up to idle", 10, 3.1, "B,D", "both", ""],
  ["situps", "situps", 10, 2.3, "B,D", "", ""],
  ["sumo_high_pull", "Sumo High Pull", 10, 2.6, "B,D", "both", ""],
]

export const MOVES = ROWS.map(([key, name, g, seconds, flags, tag, note, stamp = MOVE_STAMP]) => ({
  key, name, group: MOVE_GROUPS[g], seconds, tag, note, stamp,
  flags: flags ? flags.split(',').map((f) => FLAG_NAMES[f]) : [],
}))
const STAMP_OF = new Map(MOVES.map((m) => [m.key, m.stamp]))

/** Is this a move the library lists? */
export const isMove = (key) => STAMP_OF.has(key)
/** The stamped folder a move lives in. */
export const moveStamp = (key) => STAMP_OF.get(key) || MOVE_STAMP
/** The move's object name in MOVE_BUCKET. */
export const movePath = (key) => `clip-library/${moveStamp(key)}/${key}.glb`
